import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import cloneDeep from 'lodash/cloneDeep';

import * as MutationTypes from './mutationTypes';

const productPriceListSuccess = (state, productRecommendationMap) => {
  state.productRecommendationMap = productRecommendationMap;
};

const setProductPriceRecommendationsConfirmed = (state, { productRecommendationGuids, confirmed }) => {
  productRecommendationGuids.forEach((guid) => {
    const recommendation = cloneDeep(state.productRecommendationMap.get(guid));
    recommendation.confirmed = confirmed;
    state.productRecommendationMap.set(guid, recommendation);
  });
  state.productRecommendationMap = new Map(state.productRecommendationMap);
};

const updateProductPriceRecommendation = (state, { productRecommendation, groupCodeName, demandObject }) => {
  state.productRecommendationMap.get(productRecommendation.guid).recommendations_by_demand[groupCodeName] = demandObject;
  state.productRecommendationMap = new Map(state.productRecommendationMap);
};

const resetPointOfSaleData = (state) => {
  state.productRecommendationMap = new Map();
};

const setFilterByPriceGroup = (state, filter) => {
  state.filterByPriceGroup = filter;
};

const selectPriceLanguage = (state, language) => {
  state.optimizerLanguage = language;
};

const indexedProductPriceSuccess = (state, indexedProductPrices) => {
  state.indexedProductPrices = indexedProductPrices;
};

const useOneServiceSuccess = (state, useOneService) => {
  state.useOneService = useOneService;
};

export const mutations = {
  [MutationTypes.PRODUCT_RECOMMENDATION_MAP_SUCCESS]: productPriceListSuccess,
  [MutationTypes.SET_PRODUCT_PRICE_RECOMMENDATIONS_CONFIRMED]: setProductPriceRecommendationsConfirmed,
  [MutationTypes.UPDATE_PRODUCT_PRICE_RECOMMENDATION]: updateProductPriceRecommendation,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleData,
  [MutationTypes.SET_FILTER_BY_PRICE_GROUP]: setFilterByPriceGroup,
  [MutationTypes.SELECT_PRICE_LANGUAGE]: selectPriceLanguage,
  [MutationTypes.INDEXED_PRODUCT_PRICE_SUCCESS]: indexedProductPriceSuccess,
  [MutationTypes.USE_ONE_SERVICE_SUCCESS]: useOneServiceSuccess,
};
